const USD_LOCALE = 'en-US'
const EMPTY = '—'

interface FormatUsdOptions {
  showCents?: boolean
  compact?: boolean
  emptyFallback?: string
  fractionDigits?: number
  minFractionDigits?: number
}

function resolveDigits(options: FormatUsdOptions): {
  min: number
  max: number
} {
  const max = options.fractionDigits ?? (options.showCents === true ? 2 : 0)
  return { min: options.minFractionDigits ?? max, max }
}

export function formatUsd(
  value: number | undefined | null,
  options: FormatUsdOptions = {},
): string {
  const { compact = false, emptyFallback = EMPTY } = options
  if (value == null || !Number.isFinite(value)) return emptyFallback
  const { min, max } = resolveDigits(options)
  return value.toLocaleString(USD_LOCALE, {
    style: 'currency',
    currency: 'USD',
    notation: compact ? 'compact' : 'standard',
    minimumFractionDigits: min,
    maximumFractionDigits: max,
  })
}
